/* eslint-disable react/prop-types */

import React from "react";
import { PropTypes } from "prop-types";
import { graphql, Link } from "gatsby";
import Button from "~components/Button";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import SectionIntro from "~components/SectionIntro";
import TyperSection from "~components/TyperSection";
import PrimaryText from "~components/PrimaryText";
import People from "~components/People";

const AboutPage = ({ data, location }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout className="about-page w-full relative bg-white">
        <TyperSection
          heading={frontmatter.heading}
          imageText={frontmatter.imageText}
          imageCaption={frontmatter.imageCaption}
          imageColor="pank"
          typerColor="rad"
        />

        <PrimaryText text={frontmatter.introText} />

        <div className="grid text-orange">
          {frontmatter.introBodyColumns.map(col => (
            <article className="grid-end-4 xs:grid-end-8 xs:mt-v14 w-full">
              <h3 className="universal-sans b1 mb-v2 xs:mb-v5">{col.title}</h3>
              <p className="universal-sans b2">{col.text}</p>
            </article>
          ))}
        </div>

        <section className="w-full relative">
          <div className="grid">
            <div className="grid-end-12 grid-start-1 flex justify-center mt-v7 xs:mt-v14 mb-v7 xs:mb-v14">
              <Link to="/process">
                <Button
                  className=""
                  color="orange"
                  filled
                  text="See the process"
                />
              </Link>
            </div>
          </div>
        </section>

        <section className="w-full relative border-t-orange text-orange">
          <div className="grid pt-v7 xs:pt-v14 pb-v5 xs:pb-v10 ">
            <SectionIntro
              backgroundColor={frontmatter.recrutingHeadingColor}
              textClass="fk-screamer text-orange"
              text={frontmatter.recrutingHeading}
              className="grid-end-12 grid-start-1 py-v10 xs:py-v30 px-v5 xs:px-v5"
            />
            <p
              className="grid-end-6 xs:grid-end-8 pt-v6 xs:pt-v14 universal-sans b1"
              dangerouslySetInnerHTML={{ __html: frontmatter.recrutingText }}
            />
          </div>
        </section>

        <People people={frontmatter.people} />

        <section className="w-full relative">
          <div className="grid">
            <div className="grid-end-12 grid-start-1 xs:mt-v14 mb-v7 xs:mb-v14 flex justify-center">
              <Link to="/services">
                <Button
                  className=""
                  color="orange"
                  filled
                  text="Work with us"
                />
              </Link>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

AboutPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.shape({})
    })
  }).isRequired,
  location: PropTypes.shape({}).isRequired
};

export default AboutPage;

export const query = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        heading
        title
        imageText
        imageCaption
        introText
        introBodyColumns {
          title
          text
        }
        recrutingHeading
        recrutingHeadingColor
        recrutingText
        people {
          name
          title
          image {
            childImageSharp {
              fluid(maxWidth: 784, quality: 75) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
            publicURL
          }
          location
          text
        }
        seoDescription
        seoKeywords
      }
    }
  }
`;
